// The signed verify link carries a handoff in its URL (`ped`, `sig`, `exp`).
// It proves, to the server, that this browser is the one the lead form sent
// here; the browser never interprets it.

import { submissionIdFromSearch } from "pages/StartResume/resume";

export type Handoff = { ped: string; sig: string; exp: string };

const PED = /^[A-Za-z0-9_-]{1,2048}$/;
const SIG = /^[0-9a-f]{64}$/i;
const EXP = /^\d{1,12}$/;

/** The handoff in a URL's query, or null unless all three parts are present
 * and well formed. */
export function handoffFromSearch(search: string): Handoff | null {
  const params = new URLSearchParams(search);
  const ped = params.get("ped");
  const sig = params.get("sig");
  const exp = params.get("exp");
  if (ped === null || sig === null || exp === null) return null;
  if (!PED.test(ped) || !SIG.test(sig) || !EXP.test(exp)) return null;
  return { ped, sig, exp };
}

/** The handoff in a URL's query, only when the URL is for `submissionId`:
 * a handoff is signed for one submission and means nothing for another. */
export function handoffFor(
  search: string,
  submissionId: string,
): Handoff | null {
  const named = submissionIdFromSearch(search);
  if (named === null || named.toLowerCase() !== submissionId.toLowerCase()) {
    return null;
  }
  return handoffFromSearch(search);
}

/** The query string that carries a handoff. */
export function handoffParams(handoff: Handoff): URLSearchParams {
  return new URLSearchParams({
    ped: handoff.ped,
    sig: handoff.sig,
    exp: handoff.exp,
  });
}
